import React from 'react'
import Dashboard from '../sections/project/Dashboard'
import Project from '../sections/project/Projects'
import Footer from '../layout/footer'
import Reviews from '../sections/review/Reviews'
import { Helmet } from 'react-helmet'

const Projects = () => {
  return (
    <div>
      <Helmet>
        <title>Vwrap | Project Portfolio</title>
        <meta name="description" content="The Vwrap project portfolio contains all the diverse work we’ve done and acts as a sample, inspiration, and testament to our capabilities in our field!" />
      </Helmet>
      <Dashboard />
      <Project />
      <Reviews />
      <Footer/>
    </div>
  )
}

export default Projects
